import { useContext, useEffect, useRef, useState } from "react"
import services from "../../../services/services"
import { Urls } from "../../../services/Urls"
import { callautopopulate } from "../../../services/callautopop";
import _ from "underscore"
import { dateConvert } from "../../../utils/Helper";
import { ToastContext } from "../../../context/ToastContext";
import { useCommon } from "../../Common/useCommon";

export const useProfileRequest = () => {
    const { showSuccess, showError } = useContext(ToastContext);
    const { getValuePermission } = useCommon();
    const [options, setOptions] = useState({});
    const [filterValues, setFilterValues] = useState({});
    const [rowData, setRowdata] = useState([]);
    const [viewPopup, setViewPopup] = useState({ show: false });
    const [loader, setLoader] = useState(false);
    const tagRef = useRef();

    useEffect(() => {
        callautopopulate("request_status", "user_info").then((res) => {
            const sttausOpt = _.filter(res?.request_status, (item) => ["is_pending", "is_approved", "is_rejected"].includes(item?.request_status_key))
            setOptions({
                statusOptions: sttausOpt,
                userInfo: res?.user_info[0]
            })
            setFilterValues((prev) => ({ ...prev, status: sttausOpt[0] }))
        }).catch((error) => {
            console.error("error", error)
        })
    }, []);

    useEffect(() => {
        filterValues.status && getRequestList()
    }, [filterValues.status])


    const columns = [
        {
            key: "action",
            label: "Action",
            hide: getValuePermission("helpdesk_action_col") || filterValues?.status?.request_status_key !== "is_pending",
            headerStyle: { color: "#6B778C", textAlign: "center" },
            style: { width: "20%" },
            render: (row) => {
                const pendingId = _.findWhere(options?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
                return (
                    <div>
                        {
                            (row?.request_status_id === pendingId) &&
                            <div className="d-flex gap-2 align-items-baseline justify-content-center ">
                                <label>
                                    <input
                                        type="radio"
                                        value="is_approved"
                                        onChange={(e) => { setViewPopup({ show: true, newValue: e.target.value, id: row?.user_request_id }); }}
                                    />
                                    Approve
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        value="is_rejected"
                                        onChange={(e) => { handleRequest(e.target.value, row?.user_request_id) }
                                        }
                                    />
                                    Reject
                                </label>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            key: "employee_id",
            label: "Employee Code",
            style: { width: filterValues?.status?.request_status_key !== "is_pending" ? "10%" : "15%" },
        },
        {
            key: "requested_user_name",
            label: "Employee Name",
            style: { width: "15%" },
        },
        {
            key: "attribute_name",
            label: "Type",
            style: { width: "15%" },
        },
        {
            key: "requested_name",
            label: "Request Name",
            style: { width: filterValues?.status?.request_status_key !== "is_pending" ? "15%" : "20%" },
        },
        {
            key: "approver_user_name",
            label: filterValues?.status?.request_status_key === "is_approved" ? "Approve By" : "Rejected By",
            hide: filterValues?.status?.request_status_key !== "is_approved" && filterValues?.status?.request_status_key !== "is_rejected",
            style: { width: "15%" },
        },
        {
            key: "approve_datetime",
            label: filterValues?.status?.request_status_key === "is_approved" ? "Approved Datetime" : "Rejected DateTime",
            hide: filterValues?.status?.request_status_key !== "is_approved" && filterValues?.status?.request_status_key !== "is_rejected",
            style: { width: "15%" },
            render: (row) => {
                return <div >{dateConvert(row?.approve_datetime, "date-time-months")}</div>
            }
        },
        {
            key: "apply_datetime",
            label: "Request DateTime",
            style: { width: "15%" },
            render: (row) => {
                return <div>{dateConvert(row?.apply_datetime, "date-time-months")}</div>
            }
        },

    ]

    const getRequestList = async () => {
        try {
            setLoader(true)
            const payload = {
                request_status_id: filterValues.status?.request_status_id || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETUSERATTRIBUTESREQUESTAPPROVE"), payload);
            if (!res.body.error_status && res?.body?.data?.user_attributes_request_approve_data?.length > 0) {
                setRowdata([{
                    title: "",
                    id: "all",
                    children: res?.body?.data?.user_attributes_request_approve_data
                }])
            } else {
                setRowdata([])
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("error", error)
        }
    }



    const handleRequest = async (status, id) => {
        try {

            const requestStatus = _.findWhere(options?.statusOptions, { request_status_key: status })
            const payload = {
                "user_request_id": id || 0,
                "request_status_id": requestStatus?.request_status_id || 0,
                "approver_user_code": options?.userInfo?.user_code || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTUSERATTRIBUTESREQUESTAPPROVE"), payload)
            if (!res.body.error_status) {
                showSuccess('Success', res.body.message)
                getRequestList();
                setViewPopup({ show: false })
            }
            else {
                showError("Error", res.body.errorMessage);
            }
        } catch (error) {
            console.error("Error", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    return {
        options, filterValues, setFilterValues, rowData, columns, viewPopup, setViewPopup, handleRequest, getRequestList, loader, setLoader, tagRef
    }
}